import { connect } from 'react-redux';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import logo from '../images/logo.png';
import { C } from './general/colors';

const FEATURES = [
    {
        icon: 'fa-shopping-cart',
        color: C.primary,
        title: 'Gestión de pedidos',
        desc: 'Crea, aprueba y rastrea cada pedido en tiempo real con trazabilidad completa desde la solicitud hasta la entrega.',
    },
    {
        icon: 'fa-money',
        color: C.accent,
        title: 'Control presupuestal',
        desc: 'Asigna fondos por usuario y centro de costos. Visualiza el consumo en vivo y recibe alertas antes de superar el techo.',
    },
    {
        icon: 'fa-bar-chart',
        color: C.provider,
        title: 'Reportes exportables',
        desc: 'Genera consolidados mensuales, reportes de fondos y ejecución por contrato. Exporta a Excel con un solo clic.',
    },
];

function Home(props) {
    const { isLoggedIn } = props;

    if (isLoggedIn) return <Navigate to="/main" replace />;

    return (
        <div className="home-page">
            {/* ── Hero ── */}
            <div className="home-hero">
                <div className="home-hero-inner">
                    <img src={logo} height="52" alt="Abi" className="rounded home-hero-logo" />
                    <h1 className="home-hero-title">
                        Gestión inteligente de<br />
                        <span className="home-hero-accent">suministros y presupuestos</span>
                    </h1>
                    <p className="home-hero-sub">
                        Centraliza pedidos, controla fondos y genera reportes en tiempo real.<br />
                        Todo lo que tu entidad necesita en una sola plataforma.
                    </p>
                    <div className="home-hero-actions">
                        <Button as={Link} to="/login" variant="primary" className="home-btn-primary">
                            <i className="fa fa-sign-in" /> Ingresar
                        </Button>
                        <Button as={Link} to="/register" variant="outline-secondary" className="home-btn-secondary">
                            <i className="fa fa-user-plus" /> Registrarse
                        </Button>
                    </div>
                    <Link to="/recover-password" className="home-recover-link">
                        ¿Olvidaste tu contraseña?
                    </Link>
                </div>

                {/* Decorative stat cards */}
                <div className="home-hero-deco" aria-hidden="true">
                    <div className="home-deco-card">
                        <div className="home-deco-card-label">Pedidos gestionados</div>
                        <div className="home-deco-card-value">1,240+</div>
                        <div className="home-deco-bar-wrap">
                            <div className="home-deco-bar" style={{ width: '72%', background: C.primary }} />
                        </div>
                    </div>
                    <div className="home-deco-card">
                        <div className="home-deco-card-label">Fondos controlados</div>
                        <div className="home-deco-card-value">$8.4M</div>
                        <div className="home-deco-bar-wrap">
                            <div className="home-deco-bar" style={{ width: '58%', background: C.accent }} />
                        </div>
                    </div>
                    <div className="home-deco-card">
                        <div className="home-deco-card-label">Entidades activas</div>
                        <div className="home-deco-card-value">34</div>
                        <div className="home-deco-bar-wrap">
                            <div className="home-deco-bar" style={{ width: '45%', background: C.provider }} />
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Features ── */}
            <div className="home-features">
                {FEATURES.map((f, i) => (
                    <div key={i} className="home-feature-card">
                        <div className="home-feature-icon" style={{ background: f.color + '18', color: f.color }}>
                            <i className={`fa ${f.icon}`} />
                        </div>
                        <div className="home-feature-title">{f.title}</div>
                        <div className="home-feature-desc">{f.desc}</div>
                    </div>
                ))}
            </div>

            {/* ── Footer ── */}
            <div className="home-footer">
                <span style={{ color: 'var(--abi-muted)', fontSize: 13 }}>
                    © {new Date().getFullYear()} Abi · Gestión de suministros
                </span>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { isLoggedIn: state.isLoggedIn };
}

export default connect(mapStateToProps)(Home);
